import {
  Database,
  Report,
  DoubleCheck,
} from "../../WorkflowViewerContent/icons";

export const nodes = [
  {
    id: "startPerformanceWorkflow",
    type: "node",
    position: { x: 200, y: 20 },
    data: {
      Icon: (
        <div
          style={{
            backgroundColor: "#DDF5E0",
            width: "37px",
            height: "37px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {Database}
        </div>
      ),
      title: "Start Performance Workflow",
      subTitle: "Data Job",
      isConfigurable: false,
    },
  },
  {
    id: "loadTransactionData",
    type: "node",
    position: { x: 0, y: 200 },
    data: {
      Icon: Database,
      title: "Load Transaction Data",
      subTitle: "Data Job",
      isConfigurable: false,
    },
  },
  {
    id: "loadHoldingData",
    type: "node",
    position: { x: 400, y: 200 },
    data: {
      Icon: Database,
      title: "Load Holding Data",
      subTitle: "Data Job",
      isConfigurable: false,
    },
  },
  {
    id: "validation",
    type: "node",
    position: { x: 200, y: 400 },
    data: {
      Icon: DoubleCheck,
      title: "Validation",
      subTitle: "Dependency Check",
      isConfigurable: false,
    },
  },

  {
    id: "configureNode",
    type: "configureNode",
    position: { x: -100, y: 646 },
    onClick: () => alert("clicked"),
    data: {
      onNodeClicked: () => alert("clicked"),
      isConfigurable: true,
    },
  },
  {
    id: "createAwaPerformanceInputData",
    type: "node",
    position: { x: 200, y: 600 },
    onClick: () => alert("clicked"),
    data: {
      Icon: Database,
      title: "Create AWA Performance Input Data",
      subTitle: "Data Job",
      isConfigurable: true,
      onClick: () => alert("clicked"),
    },
  },
  {
    id: "putContextOnS3",
    type: "node",
    position: { x: 200, y: 800 },
    data: {
      Icon: Report,
      title: "Put Context on S3",
      subTitle: "Generate Reports",
      isConfigurable: false,
    },
  },
  {
    id: "finishPerformanceWorkflow",
    type: "node",
    position: { x: 200, y: 1000 },
    data: {
      Icon: DoubleCheck,
      title: "Finish Performance Workflow",
      subTitle: "Final Step",
      isConfigurable: false,
    },
  },
];
export const edges = [
  {
    id: "startPerformanceWorkflow-loadTransactionData",
    source: "startPerformanceWorkflow",
    target: "loadTransactionData",
  },
  {
    id: "startPerformanceWorkflow-loadHoldingData",
    source: "startPerformanceWorkflow",
    target: "loadHoldingData",
  },
  {
    id: "loadHoldingData-validation",
    source: "loadHoldingData",
    target: "validation",
  },
  {
    id: "loadTransactionData-validation",
    source: "loadTransactionData",
    target: "validation",
  },
  {
    id: "validation-createAwaPerformanceInputData",
    source: "validation",
    target: "createAwaPerformanceInputData",
    sourceHandle: "a",
    targetHandle: "c",
  },
  {
    id: "createAwaPerformanceInputData-putContextOnS3",
    source: "createAwaPerformanceInputData",
    target: "putContextOnS3",
  },
  {
    id: "configureNode-createAwaPerformanceInputData",
    source: "configureNode",
    target: "createAwaPerformanceInputData",
    sourceHandle: "a",
    targetHandle: "b",
    style: {
      stroke: "#0A85C7",
      strokeWidth: 2,
      strokeDasharray: "5,5",
    },
  },
  {
    id: "putContextOnS3-finishPerformanceWorkflow",
    source: "putContextOnS3",
    target: "finishPerformanceWorkflow",
  },
];
